import React from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import AuthNavbar from "components/Navbars/AuthNavbar.js";
import AuthFooter from "components/Footers/AuthFooter.js";
import routes from "routes.js";

const Auth = () => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContent.current) mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (rts) =>
    rts.map((p, k) =>
      p.layout === "/auth" ? <Route path={p.path} element={p.component} key={k} /> : null
    );

  return (
    <div
      ref={mainContent}
      style={{
        minHeight: "100vh",
        position: "relative",
        background: "linear-gradient(135deg, #0A0A1A 0%, #1E1B4B 55%, #312E81 100%)",
        color: "#fff",
        overflowX: "hidden",
      }}
    >
      {/* Decorative orbs */}
      <div
        aria-hidden="true"
        style={{
          position: "absolute", width: 520, height: 520, borderRadius: 999,
          filter: "blur(120px)", opacity: 0.4,
          background: "rgba(79,70,229,0.55)",
          top: -160, left: -120, zIndex: 0, pointerEvents: "none",
        }}
      />
      <div
        aria-hidden="true"
        style={{
          position: "absolute", width: 420, height: 420, borderRadius: 999,
          filter: "blur(120px)", opacity: 0.35,
          background: "rgba(127,119,221,0.65)",
          bottom: -120, right: -80, zIndex: 0, pointerEvents: "none",
        }}
      />
      {/* Grid overlay */}
      <div
        aria-hidden="true"
        style={{
          position: "absolute", inset: 0, zIndex: 0, pointerEvents: "none",
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px)",
          backgroundSize: "32px 32px",
          maskImage: "radial-gradient(ellipse at center, rgba(0,0,0,0.75) 0%, transparent 70%)",
          WebkitMaskImage: "radial-gradient(ellipse at center, rgba(0,0,0,0.75) 0%, transparent 70%)",
        }}
      />

      <AuthNavbar />

      <div
        style={{
          position: "relative", zIndex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: "96px 24px 32px",
        }}
      >
        <div style={{ width: "100%", maxWidth: 1100 }}>
          <Routes>
            {getRoutes(routes)}
            <Route path="*" element={<Navigate to="/auth/login" replace />} />
          </Routes>
        </div>
      </div>

      <AuthFooter />
    </div>
  );
};

export default Auth;
